import { API } from "./api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const notificationStatus = () =>
  pushSupported() ? Notification.permission : "unsupported";

async function getRegistration() {
  const existing = await navigator.serviceWorker.getRegistration("/sw.js");
  if (existing) return existing;
  return navigator.serviceWorker.register("/sw.js");
}

export async function enablePush(name) {
  if (!pushSupported()) throw new Error("unsupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");

  const reg = await getRegistration();
  await navigator.serviceWorker.ready;

  const res = await fetch(`${API}/push/vapid-public-key`);
  if (!res.ok) throw new Error("vapid-key-failed");
  const { public_key } = await res.json();

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(public_key),
    });
  }

  const saveRes = await fetch(`${API}/push/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, subscription: sub.toJSON() }),
  });
  if (!saveRes.ok) throw new Error("subscribe-failed");
  return true;
}

// Re-sync the subscription with the server when permission is already granted,
// without prompting the user. Keeps the device linked to the current account.
export async function ensurePushSubscribed(name) {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  try {
    const reg = await getRegistration();
    await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      const res = await fetch(`${API}/push/vapid-public-key`);
      const { public_key } = await res.json();
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(public_key),
      });
    }
    await fetch(`${API}/push/subscribe`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, subscription: sub.toJSON() }),
    });
    return true;
  } catch (e) {
    return false;
  }
}

export async function sendTestPush(name) {
  const res = await fetch(`${API}/push/test`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  if (!res.ok) console.error("sendTestPush failed", res.status);
  return res.ok;
}
